<template>
  <div :class="ui.bkgdColor">
    <div v-show="false"> {{getEquipRegisterCounter}} </div>
    <div v-show="false"> {{getAssetRegisterCounter}} </div>
    <div v-show="false"> {{getMaterialRegisterCounter}} </div>
    <div v-show="false"> {{getRelationshipRegisterCounter}} </div>
    <div v-show="false"> {{getActionRegisterCounter}} </div>
    <div v-show="false"> {{getFacilityRegisterCounter}} </div>
    <div v-show="false"> {{getHazardRegisterCounter}} </div>
    <div v-if="listReactive.length !== 0" class="mt-4">
      <div v-for="item in listReactive" :key="item.idi">
        <v-layout row class="ml-4 mr-4 mt-2">
          <DocumentInfoCard
          v-if="item !== null && item !== undefined"
          :data="{
            btn: 'icon',
            type: 'LINK',
            cdid: item.cdid,
            fdid: item.fdid,
            did: item.did,
            tag: item.tag}"
          />
          <ImportRemove :imported="item" v-if="enableImportRemoveFunction"/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <div :class="ui.textSubheading" v-if="item.tag !== 'A1'">
              <span class="hidden-xs-only">
                {{displayDocumentIDGTypeA(item.tag, item.idg) + " " + item.title}}
              </span>
              <span class="hidden-sm-and-up">
                {{displayDocumentIDGTypeA(item.tag, item.idg)}}
              </span>
            </div>
            <div :class="ui.textSubheading" v-if="item.tag === 'A1'">
              <span class="hidden-xs-only">
                {{item.id + " - " + item.title}}
              </span>
              <span class="hidden-sm-and-up">
                {{item.id}}
              </span>
            </div>
          </v-chip>
        </v-layout>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import master from "@/data/forms/mixins/master.js";
import ImportRemove from "@/data/import/components/ImportRemove";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import DocumentInfoCard from "@/document/info/components/DocumentInfoCard";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";

export default {
  // eslint-disable-next-line
  mixins: [
    master,
    apptheme,
    numberFunctions,
    describeDocument,
    displayFunctions
  ],
  components: {
    ImportRemove,
    DocumentInfoCard
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getCurrentPage",
      "getDetailBasic",
      "getAssetRegister",
      "getMaterialRegister",
      "getEquipRegister",
      "getRelationshipRegister",
      "getAssetRegisterCounter",
      "getMaterialRegisterCounter",
      "getActionRegister",
      "getActionRegisterCounter",
      "getEquipRegisterCounter",
      "getRelationshipRegisterCounter",
      "getRiskRegister",
      "getHazardRegister",
      "getHazardRegisterCounter",
      "getFacilityRegister",
      "getFacilityRegisterCounter"
    ]),
    list() {
      let temp = null;
      // eslint-disable-next-line
      if (this.data.tag === "A1") {
        temp = this.getAssetRegister;
      } else if (this.data.tag === "B1") {
        temp = this.getRiskRegister;
      } else if (this.data.tag === "B3") {
        temp = this.getActionRegister;
      } else if (this.data.tag === "E1") {
        temp = this.getEquipRegister;
      } else if (this.data.tag === "F1") {
        temp = this.getFacilityRegister;
      } else if (this.data.tag === "G6") {
        temp = this.getRelationshipRegister;
      } else if (this.data.tag === "L1") {
        temp = this.getMaterialRegister;
      } else if (this.data.tag === "S1") {
        temp = this.getHazardRegister;
      } else {
        temp = [];
      }

      if (temp === null || temp === undefined) {
        temp = [];
      }
      return temp;
    },
    listCounter() {
      return this.list.length;
    },
    enableImportRemoveFunction() {
      let logic = null;
      if (this.list !== null && this.list.length > 0) {
        let tag = this.list[0].tag;
        if (tag !== "B3" && this.getDetailBasic.tag !== "A1") {
          logic = true;
        } else {
          logic = false;
        }
      }
      return logic;
    }
  },
  beforeMount() {
    // to cater for bug due to array reactivity
    this.listReactive = this.list;
  },
  updated() {
    // getAttachmentListCounter triggers the counter =
    this.listReactive = this.list;
  },
  data() {
    return {
      listReactive: []
    };
  }
};
</script>
